export default __webpack_public_path__ + "static/media/urban-trash-eng-preview.fa9f9271.pdf";